module.exports = __webpack_public_path__ + "static/media/loginBackground.75aa9ab8.svg";